import { createContext } from "react";

export const headerContext = createContext();
export const bannerContext = createContext();
